// src/components/Common/VideosPlayTile.jsx
//
// Plăcuța „Play” de pe pagina principală (elev, instructor): deschide
// videoclipurile. A înlocuit ceasul decorativ, care nu avea nicio funcție.
// Folosește clasa `intro__clock`, ca să păstreze locul și dimensiunile ceasului
// pe toate ecranele. Doar butonul, fără text; la apăsare butonul „pulsează”
// scurt și abia apoi se deschide pagina.

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { prefersReducedMotion } from "../../utils/appearanceSettings";

// cât durează efectul de apăsare înainte de deschiderea paginii
const PRESS_EFFECT_MS = 260;

export default function VideosPlayTile({ to }) {
   const navigate = useNavigate();
   const [pressed, setPressed] = useState(false);
   const timerRef = useRef(0);

   useEffect(() => () => window.clearTimeout(timerRef.current), []);

   const handleClick = useCallback(
      (event) => {
         // tab nou, click cu modificatori: comportamentul obișnuit al linkului
         if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            prefersReducedMotion()
         ) {
            return;
         }

         event.preventDefault();
         if (timerRef.current) return;

         setPressed(true);
         timerRef.current = window.setTimeout(() => {
            timerRef.current = 0;
            setPressed(false);
            navigate(to);
         }, PRESS_EFFECT_MS);
      },
      [navigate, to],
   );

   return (
      <Link
         to={to}
         className={`intro__clock intro__play${pressed ? " is-pressed" : ""}`}
         aria-label="Videoclipuri"
         onClick={handleClick}
      >
         <span className="intro__play-button" aria-hidden="true">
            <svg
               className="intro__play-icon"
               viewBox="0 0 24 24"
               focusable="false"
            >
               <path d="M8 5.6v12.8a1.4 1.4 0 0 0 2.13 1.2l10.3-6.4a1.4 1.4 0 0 0 0-2.4L10.13 4.4A1.4 1.4 0 0 0 8 5.6z" />
            </svg>
         </span>
      </Link>
   );
}
